import { TicketStatusTypes, TicketUrgencyTypes } from '../../domain/custom.ticket.item';

export class TrialSetRequest {

    Disable: boolean;
    LicenseID: number;
    ProductID: number;
    DateTimeStart: Date;
    DateTimeStop: Date;
}
